// Minimal service worker registration helper
// Usage: import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '[::1]'
);

export function register(config = {}) {
  if ('serviceWorker' in navigator) {
    const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

    window.addEventListener('load', () => {
      const doRegister = () => registerValidSW(swUrl, config);
      // Register both in production and localhost to allow testing
      if (process.env.NODE_ENV === 'production' || isLocalhost) {
        doRegister();
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) return;
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // New content is available; call onUpdate callback if provided
              console.log('New content available and will be used when all tabs for this page are closed.');
              if (config && config.onUpdate) config.onUpdate(registration);
            } else {
              // Content is cached for offline use.
              console.log('Content is cached for offline use.');
              if (config && config.onSuccess) config.onSuccess(registration);
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}

export function promptSkipWaiting(registration) {
  if (!registration || !registration.waiting) return;
  // Send message to the waiting SW to skip waiting
  registration.waiting.postMessage({ type: 'SKIP_WAITING' });
}
